import React, { useState, Children } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const Beneficiaries = () => {
  const {
    register,
    watch
  } = useFormContext();
  const [specificGifts, setSpecificGifts] = useState([{
    id: 1,
    item: '',
    recipient: ''
  }]);
  const addGift = () => {
    const newId = specificGifts.length > 0 ? Math.max(...specificGifts.map(g => g.id)) + 1 : 1;
    setSpecificGifts([...specificGifts, {
      id: newId,
      item: '',
      recipient: ''
    }]);
  };
  const removeGift = (id: number) => {
    setSpecificGifts(specificGifts.filter(gift => gift.id !== id));
  };
  return <div className="space-y-8" data-id="element-257">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-258">
        <p className="text-slate-700" data-id="element-259">
          Please provide information about how you would like your assets to be
          distributed after your death.
        </p>
      </div>
      {/* Specific Gifts/Bequests */}
      <div className="space-y-4" data-id="element-260">
        <div className="flex justify-between items-center" data-id="element-261">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-262">
            Specific Gifts or Bequests (Optional)
          </h3>
          <button type="button" onClick={addGift} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-263">
            <PlusIcon size={16} className="mr-1" data-id="element-264" />
            Add Gift
          </button>
        </div>
        <p className="text-sm text-slate-600 mb-4" data-id="element-265">
          List any specific items or amounts you wish to leave to particular
          individuals.
        </p>
        {specificGifts.map((gift, index) => <div key={gift.id} className="p-4 bg-slate-50 rounded-md" data-id="element-266">
            <div className="flex justify-between items-center mb-3" data-id="element-267">
              <h4 className="font-medium" data-id="element-268">Gift {index + 1}</h4>
              {specificGifts.length > 1 && <button type="button" onClick={() => removeGift(gift.id)} className="text-red-500 hover:text-red-700" data-id="element-269">
                  <TrashIcon size={16} data-id="element-270" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-271">
              <div data-id="element-272">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-273">
                  Item or Amount
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Jewelry collection, $10,000" {...register(`specificGifts.${index}.item`)} data-id="element-274" />
              </div>
              <div data-id="element-275">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-276">
                  Recipient
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter recipient's name" {...register(`specificGifts.${index}.recipient`)} data-id="element-277" />
              </div>
            </div>
          </div>)}
      </div>
      {/* Primary Beneficiaries */}
      <div className="space-y-4" data-id="element-278">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-279">
          Primary Beneficiaries
        </h3>
        <p className="text-sm text-slate-600 mb-4" data-id="element-280">
          Who should receive the residue of your estate (everything not
          specifically given away)?
        </p>
        <div data-id="element-281">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-282">
            How would you like to distribute your estate?
          </label>
          <div className="space-y-3" data-id="element-283">
            <label className="flex items-start" data-id="element-284">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="spouse" {...register('beneficiaries.distribution')} data-id="element-285" />
              <span className="ml-2 block" data-id="element-286">
                <span className="font-medium" data-id="element-287">All to spouse</span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-288">
                  Your entire estate goes to your spouse.
                </span>
              </span>
            </label>
            <label className="flex items-start" data-id="element-289">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="spouseThenChildren" {...register('beneficiaries.distribution')} data-id="element-290" />
              <span className="ml-2 block" data-id="element-291">
                <span className="font-medium" data-id="element-292">
                  All to spouse, then to children equally if spouse predeceases
                </span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-293">
                  Your entire estate goes to your spouse, but if your spouse
                  dies before you, it's divided equally among your children.
                </span>
              </span>
            </label>
            <label className="flex items-start" data-id="element-294">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="children" {...register('beneficiaries.distribution')} data-id="element-295" />
              <span className="ml-2 block" data-id="element-296">
                <span className="font-medium" data-id="element-297">All to children equally</span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-298">
                  Your estate is divided equally among your children.
                </span>
              </span>
            </label>
            <label className="flex items-start" data-id="element-299">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="custom" {...register('beneficiaries.distribution')} data-id="element-300" />
              <span className="ml-2 block" data-id="element-301">
                <span className="font-medium" data-id="element-302">Custom distribution</span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-303">
                  Specify your own distribution plan.
                </span>
              </span>
            </label>
          </div>
        </div>
        {watch('beneficiaries.distribution') === 'custom' && <div className="mt-4" data-id="element-304">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-305">
              Custom Distribution Plan
            </label>
            <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="Describe how you want your estate distributed (e.g., 50% to spouse, 25% to each child)" {...register('beneficiaries.customPlan')} data-id="element-306" />
          </div>}
      </div>
      {/* Alternate Beneficiaries */}
      <div className="space-y-4" data-id="element-307">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-308">
          Alternate Beneficiaries
        </h3>
        <p className="text-sm text-slate-600 mb-4" data-id="element-309">
          Who should receive your estate if none of your primary beneficiaries
          survive you?
        </p>
        <div data-id="element-310">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-311">
            Alternate Beneficiaries
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter names and relationships of alternate beneficiaries" {...register('beneficiaries.alternates')} data-id="element-312" />
          <p className="text-sm text-slate-500 mt-1" data-id="element-313">
            Examples: siblings, nieces/nephews, parents, charities
          </p>
        </div>
      </div>
      {/* Age of Inheritance */}
      <div className="space-y-4" data-id="element-314">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-315">
          Age of Inheritance
        </h3>
        <div data-id="element-316">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-317">
            At what age should beneficiaries under 18 receive their inheritance?
          </label>
          <div className="flex items-center space-x-4" data-id="element-318">
            <label className="inline-flex items-center" data-id="element-319">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="18" {...register('beneficiaries.ageOfInheritance')} data-id="element-320" />
              <span className="ml-2" data-id="element-321">18</span>
            </label>
            <label className="inline-flex items-center" data-id="element-322">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="21" {...register('beneficiaries.ageOfInheritance')} data-id="element-323" />
              <span className="ml-2" data-id="element-324">21</span>
            </label>
            <label className="inline-flex items-center" data-id="element-325">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="25" {...register('beneficiaries.ageOfInheritance')} data-id="element-326" />
              <span className="ml-2" data-id="element-327">25</span>
            </label>
            <label className="inline-flex items-center" data-id="element-328">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="custom" {...register('beneficiaries.ageOfInheritance')} data-id="element-329" />
              <span className="ml-2" data-id="element-330">Other</span>
            </label>
          </div>
          {watch('beneficiaries.ageOfInheritance') === 'custom' && <div className="mt-3" data-id="element-331">
              <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter age" {...register('beneficiaries.customAge')} data-id="element-332" />
            </div>}
          <p className="text-sm text-slate-500 mt-2" data-id="element-333">
            Until this age is reached, the inheritance will be held in trust and
            managed by trustees.
          </p>
        </div>
      </div>
      {/* Guardians/Custodians */}
      <div className="space-y-4" data-id="element-334">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-335">
          Guardians for Minor Children
        </h3>
        <div data-id="element-336">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-337">
            Guardian's Name
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter guardian's name" {...register('guardians.name')} data-id="element-338" />
          <p className="text-sm text-slate-500 mt-1" data-id="element-339">
            This person will be responsible for the care of your minor children
            if both parents are deceased.
          </p>
        </div>
        <div data-id="element-340">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-341">
            Alternate Guardian's Name
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate guardian's name" {...register('guardians.alternate')} data-id="element-342" />
        </div>
        <div data-id="element-343">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-344">
            Monthly Allowance for Guardians (Optional)
          </label>
          <div className="relative" data-id="element-345">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-346">
              <span className="text-slate-500" data-id="element-347">$</span>
            </div>
            <input type="number" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Amount" {...register('guardians.monthlyAllowance')} data-id="element-348" />
          </div>
          <p className="text-sm text-slate-500 mt-1" data-id="element-349">
            This is an optional monthly amount to be provided to the guardians
            for the care of your children.
          </p>
        </div>
      </div>
    </div>;
};
export default Beneficiaries;